<div class="modifier-container-full-page">
  <mwo-breadcrumb (click)="back()" title="{{ 'planning.schedule' | translate }}"></mwo-breadcrumb>
  <div class="days-and-slots">
    <mwo-day-selector class="modifier-day-selection" [justifyContentPosition]="'space-between'" [activeDay]="activeDay$ | async"
                      (daySelected)="onActiveDayChanged($event)"></mwo-day-selector>
    <mwo-setlist-planning class="modifier-setlist-planning" [setlist]="slots$ | async"
                          [fromModifierPage]="true"
                          [isPlayingFromSchedule]="(isPlayingFromSchedule$ | async) && (isCurrentDaySelected$ | async)"
                          [activeDay]="activeDay$ | async" (scheduleModeChanged)="onActiveDayChanged($event)"
                          *ngIf="day !== '24'"></mwo-setlist-planning>
  </div>
  <div class="buttons-modify-duplicate">
    <mwo-main-button (onClick)="openModifyInterface()" text="{{'planning.modify' | translate}}"></mwo-main-button>
    <mwo-main-button (onClick)="openDuplicateInterface()" text="{{'planning.duplicate' | translate}}"></mwo-main-button>
  </div>
</div>
